import { useEffect } from "react";
import { useAppState } from "../../../store/features/app/state";
import { useAppDispatch } from "../../../store/hooks";
import { setApiError } from "../../../store/features/app/slice";
import Alert from "../../../util/alert";

const ErrorToast = () => {
	const { state } = useAppState();
	const apiError = state.apiError();
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (apiError) {
			Alert.error(apiError);
			dispatch(setApiError(null));
		}
	}, [apiError, dispatch]);

	return null;
};

export default ErrorToast;
